var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-box"},[(_vm.historyList != '')?_c('div',{staticClass:"text-jieshao"},[_c('div',{staticClass:"contentTxt"},_vm._l((_vm.historyList),function(segment,index){return _c('div',{key:index},[_vm._v("\n        "+_vm._s(segment)+"\n      ")])}),0)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8f9bf0c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/alumniHome/HistoricalIntroduction.vue
// module id = null
// module chunks = 